"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScrollableMenu = exports.MenuWithSubmenu = exports.MenuWithItemGroup = exports.MenuWithIcon = exports.BasicMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _MenuComponent = _interopRequireDefault(require("./MenuComponent"));

var _icons = require("@ant-design/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  title: "Components/Menu",
  component: _MenuComponent.default,
  argTypes: {
    multiple: {
      control: {
        type: "radio",
        options: [true, false]
      }
    },
    type: {
      control: {
        type: "select",
        options: ["basic", "scrollable", "withIcon", "submenu", "itemGroup"]
      }
    }
  }
};
exports.default = _default;

var onMenuClicked = function onMenuClicked(value) {
  console.log("====>>> onMenuClicked value ", value);
};

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_MenuComponent.default, args);
};

var BasicMenu = Template.bind({});
exports.BasicMenu = BasicMenu;
var ScrollableMenu = Template.bind({});
exports.ScrollableMenu = ScrollableMenu;
var MenuWithIcon = Template.bind({});
exports.MenuWithIcon = MenuWithIcon;
var MenuWithSubmenu = Template.bind({});
exports.MenuWithSubmenu = MenuWithSubmenu;
var MenuWithItemGroup = Template.bind({});
exports.MenuWithItemGroup = MenuWithItemGroup;
BasicMenu.args = {
  type: "basic",
  multiple: false,
  mode: "inline",
  onClick: onMenuClicked,
  items: [{
    title: "Accounts Dashboard",
    disabled: false,
    key: "1"
  }, {
    title: "Activity History",
    disabled: false,
    key: "2"
  }, {
    title: "Statements & Documents",
    disabled: false,
    key: "3"
  }],
  width: "300px"
};
ScrollableMenu.args = _objectSpread(_objectSpread({}, BasicMenu.args), {}, {
  type: "scrollable"
});
MenuWithIcon.args = {
  type: "withmenu",
  items: [{
    title: "Accounts Dashboard",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.DashboardOutlined, null),
    key: "1"
  }, {
    title: "Activity History",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.HistoryOutlined, null),
    key: "2"
  }, {
    title: "Statements & Documents",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.FileTextOutlined, null),
    key: "3"
  }],
  width: "244px",
  backgroundcolor: "#ffffff",
  menucolor: "#8C8C8C"
};
MenuWithSubmenu.args = _objectSpread(_objectSpread({}, BasicMenu.args), {}, {
  type: "submenu",
  items: [{
    title: "Accounts Dashboard",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.DashboardOutlined, null),
    key: "1"
  }, {
    title: "Activity History",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.HistoryOutlined, null),
    key: "2"
  }, {
    title: "Statements & Documents",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.FileTextOutlined, null),
    key: "3"
  }, {
    title: "Organizational Settings",
    disabled: false,
    icon: /*#__PURE__*/_react.default.createElement(_icons.ShopOutlined, null),
    key: "4"
  }, {
    title: "CONTACT US",
    disabled: false,
    icon: false,
    key: "5",
    items: [{
      title: "Secure Contact",
      disabled: false,
      icon: /*#__PURE__*/_react.default.createElement(_icons.MailOutlined, null),
      key: "6"
    }, {
      title: "Chat",
      disabled: false,
      icon: /*#__PURE__*/_react.default.createElement(_icons.CommentOutlined, null),
      key: "7"
    }, {
      title: "FAQ",
      disabled: false,
      icon: /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, null),
      key: "8"
    }]
  }]
});
MenuWithItemGroup.args = _objectSpread(_objectSpread({}, MenuWithSubmenu.args), {}, {
  type: "itemGroup"
});